export default __webpack_public_path__ + "static/media/icon-failed.ed507be0.svg";